import { Component, Input, OnInit } from '@angular/core';
import * as imageData from '../../../../../editors/sample-image-directory/imageDirTree.json';
import { NbDialogRef } from '@nebular/theme';
import { Section, ContentEnum, GridCell, RowCell, OrientationEnum } from '@urbannex/storethemes';
import { Subject, Subscription, map, takeUntil } from 'rxjs';
import { SectionBuilderStoreService } from '../../section-builder-store.service';

@Component({
  selector: 'ngx-image-editor',
  templateUrl: './image-editor.component.html',
  styleUrls: ['./image-editor.component.scss']
})
export class ImageEditorComponent implements OnInit{
  @Input() title:string;
  @Input() target:string;
  @Input() section:Section;
  @Input() contentEnum:ContentEnum;
  @Input() elId:string;

  selectedCell:GridCell | RowCell;

  imgSrc:string;
  cellId:string;
  imageData:any;
  topLevelDirectories:any[];
  items:any[];
  selectedItem:string;

  imageObjects:any[];

  isSelected = false;
  isChosen = false;
  imageCompatibility = false;

  imageOrientation:OrientationEnum;

  selectedImageWidth:number;
  selectedImageHeight:number;
  newImgSrc:string;
  newImageOrientation:string;
  newImageWidth:number;
  newImageHeight:number;

  private destroy$ = new Subject<void>();
  
  selectedCell$ = this.sectionBuilderStoreService.selectedCell$.pipe(
    takeUntil(this.destroy$),
    map(selectedCell => selectedCell)
  );
  
  constructor(
    protected ref: NbDialogRef<ImageEditorComponent>,
    private sectionBuilderStoreService:SectionBuilderStoreService
  ){}

  ngOnInit(): void {
    this.selectedCell$.subscribe(selectedCell => {
      this.selectedCell = selectedCell;
      console.log(this.selectedCell);
      this.contentEnum = this.selectedCell.contentEnum;
    })
    this.imageData = imageData;
    this.topLevelDirectories = this.imageData.children.filter(child => child["type"] == "directory");
    this.items = this.topLevelDirectories;
    this.selectedItem = this.items[0].name; 
    this.imageObjects = this.imageData.children[0].children;
  }

  selectItem(e:number){
    console.log(e);

    this.imageObjects = this.imageData.children[e].children;
  }

  close(){
    this.ref.close();
  }
  selectImage(e){
    let el = <HTMLImageElement>e.srcElement;
    let imgSrc = e.target.currentSrc;
    this.newImageHeight = el.naturalHeight;
    this.newImageWidth = el.naturalWidth;
    if(this.newImageWidth > this.newImageHeight){
      this.newImageOrientation = "landscape";
    }else{
      this.newImageOrientation = "portrait";
    }
    console.log(this.newImageOrientation);
    //console.log({Height:el.naturalHeight,Width:el.naturalWidth,src:imgSrc});
    this.newImgSrc = imgSrc;
    this.isSelected = true;
    this.isChosen = false;
    this.compareImages()
  }

  compareImages(){
    if(this.section != undefined){
      console.log(this.section);
      let sectionData = this.section.sectionData;
      let width = sectionData.width?sectionData.width:this.selectedCell.width;
      let height = sectionData.height?sectionData.height:this.selectedCell.height;
      let imageOrientation = sectionData.imageOrientation?sectionData.imageOrientation:this.selectedCell.imageOrientation
      //const imageAspectRatio = this.selectedCell.width/this.selectedCell.height;
      const imageAspectRatio = width/height;
      console.log(imageAspectRatio);
      const newAspectRation = this.newImageWidth/this.newImageHeight;
      console.log(newAspectRation);
      let aspectRatioDiff = imageAspectRatio - newAspectRation;
      let widthScale = width/this.newImageWidth;
      if(imageOrientation == this.newImageOrientation && (aspectRatioDiff < 0.8 || aspectRatioDiff > -0.8) && widthScale < 1.2){
        this.imageCompatibility = true;
      }else{
        this.imageCompatibility = false;
      }
    }
    
  }

  getEnumValue(cntEnum:ContentEnum){
    let enumValue:string;
    if(cntEnum != undefined){
      if((cntEnum).includes(".")){
        let enumKey = cntEnum.split('.')[1] as keyof typeof ContentEnum;
        enumValue = ContentEnum[enumKey];
      }else if(ContentEnum[cntEnum] != undefined){
        enumValue = ContentEnum[cntEnum]
      }else{
        enumValue = cntEnum;
      }
    }
    
    return enumValue;
    /* console.log(titleEnum)
    let title;
    if((titleEnum).includes(".")){
      let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
      title = ContentElementEnum[enumKey];
    }else if(ContentElementEnum[titleEnum] != undefined){
      title = ContentElementEnum[titleEnum]
    }else{
      title = titleEnum;
    }
    console.log(title)
    return title */
  }

  onUseImage(){
    console.log(this.newImgSrc)
    this.imgSrc = this.newImgSrc;
    this.isChosen = true;

    
    let enumValue = this.getEnumValue(this.selectedCell.contentEnum)
    console.log(enumValue);
    switch (enumValue) {
      case ContentEnum.HERO_IMAGE:
      case "Hero Image":
        console.log("Updating hero image")
        this.sectionBuilderStoreService.section$.subscribe(data => {
          console.log(data)
          data.sectionData.imgSrc = this.imgSrc;
          this.sectionBuilderStoreService.updateSection(data) 
        })
        break;
      default:
        this.selectedCell.imgSrc = this.imgSrc;
        this.sectionBuilderStoreService.updateSelectedCell(this.selectedCell);
        break;
    }
    this.ref.close();

    /* this.cellEditorStoreService.updateImageChosen(true);
    if(this.contentEnum != undefined && this.contentEnum == ContentEnum.GALLERY || this.contentEnum == ContentEnum.HERO_IMAGE || this.target == "contentElement"){
      //Update contentElement image
      let selectedContEl = this.selectedCell.contentElements.find(contentEl => contentEl.elId == this.elId);
      if(selectedContEl != undefined){
        selectedContEl.imgSrc = this.imgSrc;
        this.cellEditorStoreService.updateActiveSelector(selectedContEl);
      }else{
        console.log("contentEnum is undefined")
        if(this.contentEnum == ContentEnum.HERO_IMAGE){
          console.log("It's a Hero Image")
          let imageCell = this.selectedCell.contentElements.find(element => element.contentElementEnum == ContentElementEnum.IMAGE);
          if(imageCell != undefined){
            imageCell.imgSrc = this.imgSrc;
            this.cellEditorStoreService.updateActiveSelector(imageCell);
          }else{
            console.log("Image Cell Not found")
          }

        }
      }
      this.cellEditorStoreService.updateImgSrc(this.imgSrc);
    }else{
      this.cellEditorStoreService.updateImgSrc(this.imgSrc);
      if(this.isBackground){
        this.setImageSrc.emit(this.imgSrc);
      }else{
        this.cellEditorStoreService.updateLastActionState(LastActionEnum.IMAGE_SET);
      }
    } */
    
    
    
  }

}
